import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const ThresholdContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ThresholdProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put("settings/onboarding/threshold/new", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <ThresholdContext.Provider value={contextValue}>
      {children}
    </ThresholdContext.Provider>
  );
};

export default ThresholdProvider;
